var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.819092 10.8975V11.8484C0.819092 12.3528 1.01946 12.8365 1.37613 13.1932C1.7328 13.5499 2.21654 13.7502 2.72094 13.7502H11.2793C11.7837 13.7502 12.2674 13.5499 12.6241 13.1932C12.9808 12.8365 13.1811 12.3528 13.1811 11.8484V10.8975",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.819092 10.8975V11.8484C0.819092 12.3528 1.01946 12.8365 1.37613 13.1932C1.7328 13.5499 2.21654 13.7502 2.72094 13.7502H11.2793C11.7837 13.7502 12.2674 13.5499 12.6241 13.1932C12.9808 12.8365 13.1811 12.3528 13.1811 11.8484V10.8975",
    stroke: "#0C0C0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99991 6.4003C6.29004 6.4003 5.25332 6.29275 4.45941 6.19525C3.85289 6.12077 3.46673 5.5126 3.70834 4.95132C4.29136 3.59688 5.19291 2.34088 6.55334 1.50161C6.82717 1.33268 7.17267 1.33266 7.44651 1.50158C8.80697 2.34077 9.7085 3.59681 10.2915 4.95124C10.5331 5.51251 10.147 6.12067 9.54047 6.19517C8.74655 6.2927 7.70981 6.4003 6.99991 6.4003Z",
    fill: "white",
    stroke: "#0C0C0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.40039L7 10.8973",
    stroke: "#0C0C0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceIcon);
export default __webpack_public_path__ + "static/media/replace-icon.18a2339464920f99ae774124ba6e471a.svg";
export { ForwardRef as ReactComponent };